import { Component } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { getAllPricingTiers, FincartPricingTier } from '../fincart-pricing.constant'

@Component({
  selector: 'app-fincart-pricing-dialog',
  templateUrl: './fincart-pricing-dialog.component.html',
  styleUrl: './fincart-pricing-dialog.component.scss'
})
export class FincartPricingDialogComponent {
  pricingTiers: FincartPricingTier[] = []

  constructor(public dialogRef: MatDialogRef<FincartPricingDialogComponent>) {
    this.pricingTiers = getAllPricingTiers()
  }

  close(): void {
    this.dialogRef.close()
  }
}
